"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingWidget = void 0;
const Widget_1 = require("../../core/render/Widget");
class HeadingWidget extends Widget_1.Widget {
    constructor(headingNumber, textContent) {
        super();
        this.headingNumber = headingNumber;
        this.textContent = textContent;
        let heading = document.createElement(`h${this.headingNumber}`);
        heading.textContent = this.textContent;
        this.renderBody = heading;
    }
    shouldRender() {
        return true;
    }
}
exports.HeadingWidget = HeadingWidget;
//# sourceMappingURL=HeadingWidget.js.map